import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { RequestService } from '../../core/request.service';
import { OfflineRequestService } from '../../core/offline-request.service';
import { ApiService } from '../../core/api.service';
import { WebSocketService } from '../../core/web-socket.service';
import { Report, PostReport, PutReport } from 'src/app/interfaces/api/report';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
    providedIn: 'root'
})

export class ReportService {

    collection = "Report";
    collectionPath = "reports";
    projects: Report[] = [];

    constructor(
        private request: RequestService,
        public http: HttpClient,
        public offlineService: OfflineRequestService,
        private apiService: ApiService,
        private socket: WebSocketService,
    ) { }

    //---GET---//

    // Stays open for live socket updates (see TrackerService.getTrackers(), the same pattern -
    // the API now broadcasts a Report POST/DELETE the same way it already does for Tracker) -
    // callers that only want a one-shot snapshot should take(1)/first() themselves.
    getReports(query: QueryParams = {}): Observable<Report[]> {
        return concat(
            this.request.getCollection(this.collection, this.collectionPath, query),
            this.socket.getUpdate(this.collection)
        );
    }

    getReportLinks(): Observable<Report[]> {
        return this.apiService.getCollection(this.collectionPath, 'links');
    }

    //---POST---//

    addRepport(report: PostReport): Observable<Report> {
        return this.apiService.postCollectionData(this.collectionPath, '', report);
    }

    //---PUT---//

    updateReport(report: PutReport): Observable<any> {
        return this.apiService.updateCollectionItem(this.collectionPath, report);
    }

    //---DELETE---//

    removeReport(id: string): Observable<any> {
        return this.apiService.deleteCollectionItem(this.collectionPath, id);
    }

    deleteReportLink(blobName: string): Observable<any> {
        return this.apiService.deleteCollectionItem(this.collectionPath + 'link', blobName);
    }
}
